import React from 'react'

import "../../Style/About.css"
import {
    DiMongodb,
    DiJavascript1,
    DiReact,
    DiJava,
    DiPython,
    DiGit,
} from "react-icons/di";
import {
    SiHtml5,
    SiCss3,
    SiMysql,
    SiRedux,
    SiExpress
} from "react-icons/si";
import { FaNodeJs } from "react-icons/fa";
function TechStack({ filter }) {

    const icons = [
        { id: 1, component: <DiJavascript1 style={{ height: "95px", width: "182px" }} />, category: 'frontend' },
        { id: 2, component: <DiReact style={{ height: "95px", width: "182px" }} />, category: 'frontend' },
        { id: 3, component: <FaNodeJs style={{ height: "95px", width: "182px" }} />, category: 'backend' },
        { id: 4, component: <DiMongodb style={{ height: "95px", width: "182px" }} />, category: 'backend' },
        { id: 5, component: <DiJava style={{ height: "95px", width: "182px" }} />, category: 'backend' },
        { id: 6, component: <DiPython style={{ height: "95px", width: "182px" }} />, category: 'backend' },
        { id: 7, component: <SiExpress style={{ height: "95px", width: "182px" }} />, category: 'backend' },
        { id: 8, component: <SiRedux style={{ height: "95px", width: "182px" }} />, category: 'frontend' },
        { id: 9, component: <SiCss3 style={{ height: "95px", width: "182px" }} />, category: 'frontend' },
        { id: 10, component: <DiGit style={{ height: "95px", width: "182px" }} />, category: 'backend' },
        { id: 11, component: <SiHtml5 style={{ height: "95px", width: "182px" }} />, category: 'frontend' },
        { id: 12, component: <SiMysql style={{ height: "95px", width: "182px" }} />, category: 'backend' },
        // Add more icons as needed
    ];

    const filteredIcons = filter === 'all' ? icons : icons.filter(icon => icon.category === filter);
    
    return (
        <div className='TechStack'>

            {
                filteredIcons.map(icon => (
                    <div key={icon.id} className='techstack-div'>{icon.component}</div>
                ))
            }


        </div>
    )
}

export default TechStack